export class ItemSearchCatalogDto {
    itemNumber: string | null = null;
    isbn: String | null = null;
    itemDescription: String | null = null;
    editionYear: number | null = null;
    productStatus: string | null = null;
    acronym: string | null = null;
}